module.exports = __webpack_public_path__ + "static/img/sprite-4.e60575e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite-4.svg
// module id = iR/y
// module chunks = 1